import { useState } from "react";
import { toast } from "sonner";
import { Mail, Send } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const API = process.env.REACT_APP_BACKEND_URL;

const inputCls =
  "w-full rounded-xl border border-white/15 bg-black/40 px-4 py-3 font-body text-sm text-white placeholder:text-white/30 focus:border-[#00A8E0] focus:outline-none";

export const AdminComposer = ({ open, onClose, code, initial, accent = "#00A8E0" }) => {
  const [form, setForm] = useState({ template: "reply", ...initial });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const send = async (e) => {
    e.preventDefault();
    if (!form.to_email || !form.to_name || !form.subject || !form.message) {
      toast.error("All fields are required.");
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API}/api/admin/send-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Admin-Code": code },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error();
      toast.success(`Email sent to ${form.to_email}`);
      onClose();
    } catch {
      toast.error("Failed to send. Try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="admin-composer" className="max-w-xl max-h-[85vh] overflow-y-auto border-white/15 bg-[#0a192f] p-8">
        <DialogTitle className="font-serif-display text-2xl font-medium text-white flex items-center gap-3">
          <Mail size={20} style={{ color: accent }} /> Send Email / Message
        </DialogTitle>
        <form onSubmit={send} className="mt-4 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input data-testid="composer-name" className={inputCls} placeholder="Recipient name *" value={form.to_name} onChange={set("to_name")} />
            <input data-testid="composer-email" type="email" className={inputCls} placeholder="Recipient email *" value={form.to_email} onChange={set("to_email")} />
          </div>
          <input data-testid="composer-subject" className={inputCls} placeholder="Subject *" value={form.subject} onChange={set("subject")} />
          <textarea data-testid="composer-message" rows={7} className={inputCls} placeholder="Your message *" value={form.message} onChange={set("message")} />
          <p className="font-body text-[11px] text-white/35 leading-relaxed">
            Sent from info@heritagefamilypa.com with the Heritage branded email template.
          </p>
          <button
            type="submit"
            disabled={sending}
            data-testid="composer-send-btn"
            className="btn-sweep w-full inline-flex items-center justify-center gap-2 rounded-full px-8 py-3.5 font-body text-sm font-semibold tracking-wide text-white disabled:opacity-60"
            style={{ backgroundColor: accent }}
          >
            {sending ? "Sending..." : "Send"} <Send size={15} />
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
